<template>
  <div
    class="full-item flex flex-direction justify-center align-center login-container"
  >
    <el-card
      :class="
        (UI.isMobile ? 'full-item' : 'margin-bottom-100') +
          ' ' +
          (UI.clientHeight < 800 ? 'scroll-y' : '')
      "
    >
      <div slot="header" class="clearfix">
        <span>登录</span>
      </div>
      <Login :class="UI.isMobile ? 'mobile-login-box' : 'login-box'"></Login>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Login from './login.vue';

export default {
  components: {
    Login,
  },

  computed: {
    ...mapState(['UI']),
  },

  methods: {
    toRegistry: function() {
      this.$router.replace({
        name: 'registry',
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/login/index.vue